<script>
export default {
  props: {
    value: Object,
  },
}
</script>

<template>
  <i18n :path="`${value.event}:${value.data.type}`" tag="div">
    <template #phone>
      <a :href="`tel:${value.data.url}`" target="_blank">{{ value.data.url }}</a>
    </template>
    <template #email>
      <a :href="`mailto:${value.data.url}`" target="_blank">{{ value.data.url }}</a>
    </template>
  </i18n>
</template>
